import script from "./NumericsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumericsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./NumericsWidget.vue?vue&type=style&index=0&id=22f54439&lang=scss"

const __exports__ = script;

export default __exports__